module.exports = ".logo {\n  padding: 12px 30px; }\n  @media (min-width: 1300px) {\n    .logo span.logo-lg {\n      display: block; }\n    .logo span.logo-sm {\n      display: none; } }\n  @media (max-width: 800px) {\n    .logo span.logo-lg {\n      display: none; }\n    .logo span.logo-sm {\n      display: block; } }\n  .noVisible {\n  display: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/left-sidebar/left-sidebar.component.scss
// module id = ./src/app/components/partials/left-sidebar/left-sidebar.component.scss
// module chunks = main